export default {"src":"/_next/static/media/cc.6867a603.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};